import { useEffect } from 'react';
import { useAppSelector } from '@/stores/hooks';
import { selectSurveyLanguage } from '@/stores/selectors';

const CN_CLASS = 'survey-lang-cn';

/**
 * Syncs survey language onto <html> so CN-wide CSS (uniform font-weight) can apply.
 */
export default function SurveyLanguageDocumentSync() {
  const surveyLanguage = useAppSelector(selectSurveyLanguage);

  useEffect(() => {
    const root = document.documentElement;
    if (surveyLanguage === 'cn') {
      root.classList.add(CN_CLASS);
      root.lang = 'zh-CN';
    } else {
      root.classList.remove(CN_CLASS);
      root.lang = surveyLanguage === 'bm' ? 'ms' : 'en';
    }
  }, [surveyLanguage]);

  return null;
}
